import { createFileRoute, redirect } from '@tanstack/react-router'
import { CollectionGrid } from '../../components/public-kb/CollectionGrid'
import { PublicKbHero } from '../../components/public-kb/PublicKbHero'
import { PublicKbLandingSkeleton } from '../../components/public-kb/PublicKbLandingSkeleton'
import {
  publicCollectionsQueryOptions,
  usePublicCollections,
} from '../../hooks/usePublicKb'
import { usePageMeta } from '../../hooks/usePageMeta'
import { isPublicKbHost } from '../../lib/public-kb-host'

export const Route = createFileRoute('/knowledge/')({
  beforeLoad: async ({ context }) => {
    if (!isPublicKbHost()) {
      throw redirect({ to: '/' })
    }

    await context.queryClient.ensureQueryData(publicCollectionsQueryOptions())
  },
  component: PublicKbLandingPage,
})

function PublicKbLandingPage() {
  const { publicWorkspace } = Route.useRouteContext()
  const { data: collections, isLoading } = usePublicCollections()

  usePageMeta(
    publicWorkspace
      ? {
          title: `${publicWorkspace.name} Help Center`,
          description: `Find answers and browse help articles from ${publicWorkspace.name}.`,
          image: publicWorkspace.logo ?? publicWorkspace.headerImage?.url ?? undefined,
          url: typeof window !== 'undefined' ? window.location.href : undefined,
        }
      : null,
  )

  if (!publicWorkspace) return null

  if (isLoading) {
    return <PublicKbLandingSkeleton />
  }

  return (
    <>
      <PublicKbHero
        title="Help center"
        subtitle="Search for answers or browse by topic"
        headerImage={publicWorkspace.headerImage}
        brandColor={publicWorkspace.brandColor}
      />
      <CollectionGrid collections={collections ?? []} />
    </>
  )
}
